import React, { useState } from "react";
import {
  Button,
  FormContainer,
  FormSuccessContainer,
  FormDisclaimer,
  FormMicroComponentContainer,
  SalesforceContactFormWrapper,
} from "./salesforce-contact-form.styled";
import {
  FormMicroComponent,
  singleFormProps,
} from "../customer-quote-request/customer-quote-request";
import {
  FormProps,
  SubmittedFormData,
} from "../customer-quote-request/form-stepper-component";
import { contactFormId } from "../../utils/constants";
import { useSubmitContactFormMutation } from "../../types/queries";
import { identify } from "../../utils/analytics";
import { useSalesforceViewContext } from "../../utils/salesforce-form-context";
import { PrismicRichTextField } from "../../types/graphql";
import { PrismicRichText } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";

interface ISalesforceContactFormProps {
  leadSource: string | any;
  disclaimer: PrismicRichTextField | any;
  children: React.ReactNode;
}

const SalesforceContactForm = (props: ISalesforceContactFormProps) => {
  const [formEmail, setFormEmail] = useState<string | undefined>();
  const [submitContactForm] = useSubmitContactFormMutation();

  const formViewState = useSalesforceViewContext();

  const identifyFromForm = (formData: SubmittedFormData[]) => {
    const emailAddress = formData.find((data) => data.key === "email");
    const company = formData.find((data) => data.key === "company");
    const firstName = formData.find((data) => data.key === "firstName");
    const lastName = formData.find((data) => data.key === "lastName");
    const jobTitle = formData.find((data) => data.key === "jobTitle");
    const phone = formData.find((data) => data.key === "phone");
    identify({
      email: emailAddress?.value,
      company_name: company?.value,
      name: `${firstName?.value} ${lastName?.value}`,
      job_title: jobTitle?.value,
      phone: phone?.value,
    });
  };

  const contactFormProps: FormProps = {
    config: {
      ...singleFormProps.config,
      singleForm: {
        id: contactFormId,
        onSubmit: async (formData) => {
          const submissionResponse = await submitContactForm({
            variables: {
              input: {
                formId: contactFormId,
                leadSource: props.leadSource,
                formFieldsResponses: formData,
              },
            },
          });
          if (
            submissionResponse.data?.submitContactForm?.status === "success"
          ) {
            formViewState.setCurrentView("formSuccess");
            identifyFromForm(formData);
            const emailAddress = formData.find((data) => data.key === "email");
            setFormEmail(emailAddress?.value);
            return true;
          }
          return false;
        },
        onClose: () => {
          formViewState.setCurrentView("info");
        },
      },
    },
  };

  return (
    <>
      {props.children}
      {formViewState.currentView !== "info" && (
        <SalesforceContactFormWrapper>
          {formViewState.currentView === "form" && (
            <FormContainer>
              {/* TODO: Add loader */}
              <FormMicroComponentContainer>
                <FormMicroComponent {...contactFormProps} />
              </FormMicroComponentContainer>
              <FormDisclaimer>
                <PrismicRichText
                  field={props?.disclaimer}
                  components={htmlSerializer}
                />
              </FormDisclaimer>
            </FormContainer>
          )}
          {formViewState.currentView === "formSuccess" && (
            <FormSuccessContainer>
              <p>
                Your Request Form has been submitted! Our team will email you at{" "}
                {formEmail} once your request has been reviewed.
              </p>
              <Button
                kind="outline-blue"
                scale="large"
                onClick={() => {
                  formViewState.setCurrentView("info");
                }}
              >
                Continue
              </Button>
            </FormSuccessContainer>
          )}
        </SalesforceContactFormWrapper>
      )}
    </>
  );
};
export default SalesforceContactForm;
